/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockReturnOutDtEditor extends Serenity.Extensions.GridEditorBase<IcStockReturnOutDtRow> {
        protected getColumnsKey() { return "Inventory.IcStockReturnOutDt"; }
        protected getDialogType() { return IcStockReturnOutDtDialog; }
        protected getLocalTextPrefix() { return IcStockReturnOutDtRow.localTextPrefix; }

        public myPassValue: string;
        public myPassValue2: number;
       
        constructor(container: JQuery) {
            super(container);

        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text(" สร้างรายการ"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    hotkey: 'alt+shift',
                    onClick: () => {
                        this.createEntityDialog(this.getItemType(), dlg => {


                            var dialog = dlg as IcStockReturnOutDtDialog;
                            dialog.onSave = (opt, callback) => this.save(opt, callback);
                            var entity = this.getNewEntity() as IcStockReturnOutDtRow;

                            entity.SysDocNo = this.myPassValue;
                            if (this.myPassValue2 == 1) {
                                entity.Id = -1;
                            }



                            dialog.loadEntityAndOpenDialog(entity, false);
                        });
                    },
                }
            );

            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }
        validateEntity(row, id) {
            row.PurUnitPrice = (row.CostValue || 0) / (row.Qty || 1);
            row.UnitCost = (row.CostValue || 0) / ((row.Qty || 1) * (row.PurUnitRatio));
            return true;
        }


        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            // //--set new set of grid columns---
            // //--get content width
            // let ele = document.getElementsByClassName("grid-container");
            // var bordermg = 60;
            // var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            // var totalcolw = 0;

            // let propItems = this.getPropertyItems();
            // let items = this.getColumns();
            // items.forEach((item, idx) => {
            //     let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
            //     totalcolw += pItem.width;

            // });
            // items.forEach((item, idx) => {
            //     let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
            //     pItem.resizable = true;
            //     pItem.width = (eleWidth / totalcolw) * pItem.width;


            // });

            // let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            // grid.setColumns(c);
            // grid.resizeCanvas();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    //new Slick.Aggregators.Sum('PurUnitRatio'),
                    //new Slick.Aggregators.Sum('PurUnitPrice'),
                    //new Slick.Aggregators.Sum('UnitCost'),
                    new Slick.Aggregators.Sum('CostValue')
                ]
            });
            return grid;
        }


        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }
        private _CallGR: string;
        public get CallGR(): string { return this._CallGR; }
        set CallGR(value: string) {
            if (this._CallGR != value) {

                var row = IcStockReceiveDtRow.getLookup().items.filter(x => x.SysDocNo == value)
                this.clearDataGrid();
                var i = 0;
                for (var po of row) {
                    i++;
                    var item = <IcStockReturnOutDtRow>{
                        LineItemNo: i,
                        SkuCode: po.SkuCode,
                        ItemRemark: po.ItemRemark,
                        Qty: po.Qty,
                        PurUnit: po.PurUnit,
                        UnitChange: po.UnitChange,
                        PurUnitPrice: po.PurUnitPrice,
                        CostValue: po.CostValue,
                        UnitCost: po.UnitCost,
                        PurUnitRatio: po.PurUnitRatio,
                        GRLineId: po.Id,
                        GRRefFg: po.SysDocNo

                    };
                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()] = id;
                    this.view.addItem(item);
                }

                this.refresh();
            }
        }

        public clearDataGrid() {
            this.view.setItems([], true);
        }

    }
}

